import React from 'react'
import { BsLinkedin, BsGithub } from 'react-icons/bs'
import { FiMail } from 'react-icons/fi'

const Contact = () => {
  return (
    <div>
      {/* contact section */}
      <div
        name="contact"
        className="w-full h-[500px] bg-[#fffbf3] flex justify-center items-center p-20"
      >
        <div className="text-center">
          <p className="text-3xl font-bold inline border-b-4 border-[#907aff]">
            Let's connect
          </p>
          <p className="py-8">
            Get in touch for opportunities or just to say hi 👋
          </p>

          {/* social icons */}
          <ul className="py-4">
            <li className="inline-block justify-center items-center mx-2 ">
              <a
                href="https://www.linkedin.com/in/rebecca-l-626185130/"
                target="_blank"
                rel="noreferrer"
              >
                <BsLinkedin size={25} />
              </a>
            </li>
            <li className="inline-block justify-center items-center mx-2">
              <a href="/" target="_blank" rel="noreferrer">
                <FiMail size={25} />
              </a>
            </li>
            <li className="inline-block justify-center items-center mx-2">
              <a
                href="https://github.com/yingerliang"
                target="_blank"
                rel="noreferrer"
              >
                <BsGithub size={25} />
              </a>
            </li>
          </ul>

          {/* footer */}
          <div className="mt-8">
            <a
              href="https://github.com/yingerliang"
              target="_blank"
              rel="noreferrer"
              className="text-[#907aff] font-bold hover:text-[#56a2fa]"
            >
              Designed & Built by Rebecca Liang
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact
